/**
 * CookieConsent - GDPR cookie consent banner
 * Shows once, remembers choice in localStorage
 */
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";

const COOKIE_KEY = "etesa_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted: false, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-3xl mx-auto bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-slate-200 p-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Shield className="w-8 h-8 text-teal-600 shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-slate-800">
              Cookies & Confidențialitate
            </p>
            <p className="text-xs text-slate-500 mt-1">
              Folosim cookies strict necesare pentru autentificare și funcționarea platformei. 
              Nu folosim cookies de tracking sau marketing. 
              Consultați{" "}
              <button
                onClick={() => navigate("/legal?tab=privacy")}
                className="text-teal-600 hover:underline font-medium"
              >
                Politica de Confidențialitate
              </button>
              {" "}pentru detalii.
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="text-xs"
              data-testid="cookie-decline-btn"
            >
              Doar necesare
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-teal-600 hover:bg-teal-700 text-white text-xs"
              data-testid="cookie-accept-btn"
            >
              Accept toate
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
